<template>
    <div class="ui-facebook-integration-card">
        <ui-image :src="data.image" 
            :alt="data.name"
            v-if="data.image"
            h="50" 
            w="50" />
        <div v-else class="fac-image" />
        
        <div v-if="data.name" class="ui-facebook-integration-card-title">{{ data.name }}</div>
    </div> 
</template>

<script>
    import { uiImage } from '@/components/ui'

    export default {
        components: {
            uiImage
        },
        props: {
            data: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
        },
        computed: {
            titleComputed() {
                return this.data.name
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>